export default "__VITE_ASSET__BFKjNe4f__"